import { DsFormInstanceSchemaFieldInterface } from '../interfaces/form-instance/ds-form-instance-schema-field.interface';
import { DsFormInstanceSchemaInterface } from '../interfaces/form-instance/ds-form-instance-schema.interface';
import { DsFormInstanceSchemaField } from './ds-form-instance-schema-field';

export class DsFormInstanceSchema {
  /**
   *
   */
  public id: number;

  /**
   *
   */
  public label: string;

  /**
   *
   */
  public creation_date: number;

  /**
   *
   */
  public status: number;

  /**
   *
   */
  public fields: DsFormInstanceSchemaFieldInterface[];

  /**
   * Creates an instance of DsFormInstance.
   *
   * @param json the json data
   */
  constructor(json: DsFormInstanceSchemaInterface) {
    this.id = json.id;
    this.label = json.label;
    this.status = json.status;
    this.creation_date = json.creation_date;

    this.initiateField(json.fields);
  }

  /**
   * Initiate Fields list by constructor.
   *
   * @param jsonFields json list fields
   */
  private initiateField(jsonFields): void {
    this.fields = jsonFields.map((field) => new DsFormInstanceSchemaField(field));
  }
}
